Vue.component('recipes-table', () => import(/* webpackChunkName: "recipes-table" */ '@modulesPages/Recipe/Resources/assets/js/Tables/RecipesTable'))
Vue.component('recipe-ingredients-table', () => import(/* webpackChunkName: "recipe-ingredients-table" */ '@modulesPages/Recipe/Resources/assets/js/Tables/RecipeIngredientsTable'))
Vue.component('recipe-steps-table', () => import(/* webpackChunkName: "recipe-steps-table" */ '@modulesPages/Recipe/Resources/assets/js/Tables/RecipeStepsTable'))

Vue.component('recipes-form', () => import(/* webpackChunkName: "recipes-form" */ '@modulesPages/Recipe/Resources/assets/js/Forms/Recipes/RecipesForm'))
Vue.component('recipe-ingredients-form', () => import(/* webpackChunkName: "recipe-ingredients-form" */ '@modulesPages/Recipe/Resources/assets/js/Forms/RecipeIngredients/RecipeIngredientsForm'))
Vue.component('recipe-steps-form', () => import(/* webpackChunkName: "recipe-steps-form" */ '@modulesPages/Recipe/Resources/assets/js/Forms/RecipeSteps/RecipeStepsForm'))

Vue.component('recipes-card', () => import(/* webpackChunkName: "recipes-card" */ '@modulesPages/Recipe/Resources/assets/js/Cards/RecipesCard'))
Vue.component('recipes-card2', () => import(/* webpackChunkName: "recipes-card2" */ '@modulesPages/Recipe/Resources/assets/js/Cards/RecipesCard2'))

Vue.component('recipes-section', () => import(/* webpackChunkName: "recipes-section" */ '@modulesPages/Recipe/Resources/assets/js/Sections/RecipesSection'))
Vue.component('new-recipes-section', () => import(/* webpackChunkName: "new-recipes-section" */ '@modulesPages/Recipe/Resources/assets/js/Sections/NewRecipesSection'))



Vue.component('recipes-card3', () => import(/* webpackChunkName: "recipes-card3" */ '@modulesPages/Recipe/Resources/assets/js/Cards/RecipesCard3'))
Vue.component('recipe-section', () => import(/* webpackChunkName: "recipe-section" */ '@modulesPages/Recipe/Resources/assets/js/Sections/RecipeSection'))


app.$Util.formattedClassName = {
    ...app.$Util.formattedClassName,
    ...{
        'Modules\\Recipe\\Entities\\Recipe': 'Receta',
        'Modules\\Recipe\\Entities\\RecipeIngredient': 'Ingrediente de Receta',
        'Modules\\Recipe\\Entities\\RecipeStep': 'Paso de Receta'
    }   
}

app.$Util.tableNameByClassName = {
	...app.$Util.tableNameByClassName,
	...{
		'Modules\\Recipe\\Entities\\Recipe': 'recipes',
		'Modules\\Recipe\\Entities\\RecipeIngredient': 'recipe_ingredients',
		'Modules\\Recipe\\Entities\\RecipeStep': 'recipe_steps'
	}	
}

app.$Util.classNameByTableName = {
	...app.$Util.classNameByTableName,
	...{
		'recipes': 'Modules\\Recipe\\Entities\\Recipe',
		'recipe_ingredients': 'Modules\\Recipe\\Entities\\RecipeIngredient',
		'recipe_steps': 'Modules\\Recipe\\Entities\\RecipeStep'
	}	
}